module.exports = __webpack_public_path__ + "img/centrifuge-A.b9c3e66d.png";